import { render, staticRenderFns } from "./LoginOtp.vue?vue&type=template&id=f68fd48a"
import script from "./LoginOtp.vue?vue&type=script&lang=js"
export * from "./LoginOtp.vue?vue&type=script&lang=js"
import style0 from "./LoginOtp.vue?vue&type=style&index=0&id=f68fd48a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports